<div class='q-a__info'>
  <p class='q-a__question'>{{ questionLabel }}</p>
  <p class='q-a__answer'>{{ answerLabel }}</p>
</div>
